import React from "react";

function Hero() {
  return (
    <div id="top" className="container mt-3">
      <div className="row align-items-center">
        <div className="col-auto">
          <img
            className="hero-avatar"
            src="https://ui-avatars.com/api/?name=Tanveer+Singh&size=150&background=1f2937&color=fff"
            alt="Tanveer Singh avatar"
          />
        </div>
        <div className="col">
          <h1 className="fs-2 mt-3 mt-md-0">
            Hey, I'm Tanveer Singh. I'm a Software Developer.
            <span className="badge-open">Open to work</span>
          </h1>
{/* <h1 className="fs-2 mt-3 mt-md-0">
            Hi, I'm Tanveer Singh.A Full-Stack Software Developer.
            <span className="badge-open">Open to work</span>
          </h1> */}
          <p className="hero-location mb-2">
            <i className="fa-solid fa-location-dot me-1"></i>
            Patiala, Punjab, India
          </p>
          <div className="hero-socials">
            <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="https://github.com/tanveer-deol" target="_blank" rel="noreferrer">
              <i className="fa-brands fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;